export default "__VITE_ASSET__cdIvyMPO__"